var map = {
	"./10s.png": 30006,
	"./1s.png": 65100,
	"./2s.png": 99367,
	"./3s.png": 52716,
	"./4s.png": 92113,
	"./5s.png": 2164,
	"./6s.png": 80533,
	"./7s.png": 69700,
	"./8s.png": 8236,
	"./9s.png": 33261
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37630;